import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "pb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "bg-colors"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#bg-colors" }),
  /*#__PURE__*/_createTextVNode(" Background Colors ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, " Easily set the background of an element to any contextual class as shown below: ", -1)
const _hoisted_6 = { class: "py-5" }
const _hoisted_7 = { class: "rounded border p-10" }
const _hoisted_8 = { class: "py-5" }
const _hoisted_9 = { class: "py-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "light-bg-colors"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#light-bg-colors" }),
  /*#__PURE__*/_createTextVNode(" Light Background Colors ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("code", null, ".bg-light-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's light background color defined with "),
  /*#__PURE__*/_createElementVNode("code", null, "$theme-light-colors"),
  /*#__PURE__*/_createTextVNode(" in "),
  /*#__PURE__*/_createElementVNode("code", null, "sass/_variables.scss"),
  /*#__PURE__*/_createTextVNode(": ")
], -1)
const _hoisted_12 = { class: "py-5" }
const _hoisted_13 = { class: "rounded border p-10" }
const _hoisted_14 = { class: "py-5" }
const _hoisted_15 = { class: "py-10" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "hover-bg-colors"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#hover-bg-colors" }),
  /*#__PURE__*/_createTextVNode(" Hover Background Colors ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("code", null, ".bg-hover-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's hover background color: ")
], -1)
const _hoisted_18 = { class: "py-5" }
const _hoisted_19 = { class: "rounded border p-10" }
const _hoisted_20 = { class: "py-5" }
const _hoisted_21 = { class: "py-10" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "hover-light-bg-colors"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#hover-light-bg-colors" }),
  /*#__PURE__*/_createTextVNode(" Hover Light Background Colors ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("code", null, ".bg-hover-light-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's hover light background color: ")
], -1)
const _hoisted_24 = { class: "py-5" }
const _hoisted_25 = { class: "rounded border p-10" }
const _hoisted_26 = { class: "py-5" }
const _hoisted_27 = { class: "py-10" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "hoverable-bg-colors"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#hoverable-bg-colors" }),
  /*#__PURE__*/_createTextVNode(" Hoverable Background Colors ")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("code", null, ".hoverable"),
  /*#__PURE__*/_createTextVNode(" with "),
  /*#__PURE__*/_createElementVNode("code", null, ".bg-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's background color with hover state: ")
], -1)
const _hoisted_30 = { class: "py-5" }
const _hoisted_31 = { class: "rounded border p-10" }
const _hoisted_32 = { class: "py-5" }
const _hoisted_33 = { class: "py-10" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "hoverable-bg-colors"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#hoverable-bg-colors" }),
  /*#__PURE__*/_createTextVNode(" Hoverable Light Background Colors ")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("code", null, ".hoverable"),
  /*#__PURE__*/_createTextVNode(" with "),
  /*#__PURE__*/_createElementVNode("code", null, ".bg-light-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's light background color with hover state: ")
], -1)
const _hoisted_36 = { class: "py-5" }
const _hoisted_37 = { class: "rounded border p-10" }
const _hoisted_38 = { class: "py-5" }
const _hoisted_39 = { class: "py-10" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "opacity"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#opacity" }),
  /*#__PURE__*/_createTextVNode(" Opacity ")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("code", null, ".bg-opacity-{0, 5, 10, 15, 20, 25, 50, 75, 100}"),
  /*#__PURE__*/_createTextVNode(" class with "),
  /*#__PURE__*/_createElementVNode("code", null, ".bg-{color}"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("code", null, ".bg-light-{color}"),
  /*#__PURE__*/_createTextVNode(" to set an element's background color with opacity: ")
], -1)
const _hoisted_42 = { class: "py-5" }
const _hoisted_43 = { class: "rounded border p-10 d-flex flex-wrap" }
const _hoisted_44 = { class: "fw-bold py-2" }
const _hoisted_45 = { class: "py-5" }
const _hoisted_46 = { class: "pt-10" }
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"bg-image-classes\"><a href=\"#bg-image-classes\"></a> Background Image Classes </h1><div class=\"py-5\"> Assign background image style values to an element with shorthand classes with the format <code>bgi-{property}</code>. </div><div class=\"py-5\"> Where <code>property</code> is one of: <ul class=\"pt-3\"><li class=\"py-2\"><code>size-length</code> to set <code>background-size: length</code></li><li class=\"py-2\"><code>size-cover</code> to set <code>background-size: cover</code></li><li class=\"py-2\"><code>size-contain</code> to set <code>background-size: contain</code></li><li class=\"py-2\"><code>no-repeat</code> to set <code>background-repeat: no-repeat</code></li><li class=\"py-2\"><code>position-y-top</code> to set <code>background-position-y: top</code></li><li class=\"py-2\"><code>position-y-bottom</code> to set <code>background-position-y: bottom</code></li><li class=\"py-2\"><code>position-y-center</code> to set <code>background-position-y: center</code></li><li class=\"py-2\"><code>position-x-left</code> to set <code>background-position-x: left</code></li><li class=\"py-2\"><code>position-x-right</code> to set <code>background-position-x: right</code></li><li class=\"py-2\"><code>position-x-center</code> to set <code>background-position-x: center</code></li><li class=\"py-2\"><code>position-bottom</code> to set <code>background-position: 0 bottom</code></li><li class=\"py-2\"><code>position-center</code> to set <code>background-position: center</code></li></ul></div>", 3)
const _hoisted_50 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors.backgroundColors, (item, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: i,
                class: _normalizeClass([`bg-${item} text-inverse-${item}`, "p-3 fw-bold fw-6"])
              }, " .bg-" + _toDisplayString(item), 3))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="bg-white"></div>
            <div class="bg-primary"></div>
            <div class="bg-light"></div>
            <div class="bg-secondary"></div>
            <div class="bg-success"></div>
            <div class="bg-info"></div>
            <div class="bg-warning"></div>
            <div class="bg-danger"></div>
            <div class="bg-dark"></div>
            `))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors.lightBackgroundColors, (item, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: i,
                class: _normalizeClass([`bg-light-${item} text-${item}`, "p-3 fw-bold fw-6"])
              }, " .bg-light-" + _toDisplayString(item), 3))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="bg-light-primary text-primary"></div>
            <div class="bg-light-success text-success"></div>
            <div class="bg-light-info text-info"></div>
            <div class="bg-light-warning text-warning"></div>
            <div class="bg-light-danger text-danger"></div>
            <div class="bg-light-dark text-dark"></div>
            `))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors.backgroundColors, (item, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: i,
                class: _normalizeClass([`bg-hover-${item}`, "text-gray-600 p-3 fw-bold fw-6"])
              }, " .bg-hover-" + _toDisplayString(item), 3))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="bg-hover-white"></div>
            <div class="bg-hover-primary"></div>
            <div class="bg-hover-light"></div>
            <div class="bg-hover-secondary"></div>
            <div class="bg-hover-success"></div>
            <div class="bg-hover-info"></div>
            <div class="bg-hover-warning"></div>
            <div class="bg-hover-danger"></div>
            <div class="bg-hover-dark"></div>
            `))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors.lightBackgroundColors, (item, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: i,
                class: _normalizeClass([`bg-hover-light-${item}`, "text-gray-600 p-3 fw-bold fw-6"])
              }, " .bg-hover-light-" + _toDisplayString(item), 3))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="bg-hover-light-primary"></div>
            <div class="bg-hover-light-success"></div>
            <div class="bg-hover-light-info"></div>
            <div class="bg-hover-light-warning"></div>
            <div class="bg-hover-light-danger"></div>
            <div class="bg-hover-light-dark"></div>
            `))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors.backgroundColors, (item, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: i,
                class: _normalizeClass([`bg-${item}`, "text-gray-600 hoverable p-3 fw-bold fw-6"])
              }, " .bg-" + _toDisplayString(item) + " .hoverable ", 3))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="bg-white hoverable"></div>
            <div class="bg-primary hoverable"></div>
            <div class="bg-light hoverable"></div>
            <div class="bg-secondary hoverable"></div>
            <div class="bg-success hoverable"></div>
            <div class="bg-info hoverable"></div>
            <div class="bg-warning hoverable"></div>
            <div class="bg-danger hoverable"></div>
            <div class="bg-dark hoverable"></div>
            `))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors.backgroundColors, (item, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: i,
                class: _normalizeClass([`bg-light-${item}`, "text-gray-600 hoverable p-3 fw-bold fw-6"])
              }, " .bg-light-" + _toDisplayString(item) + " .hoverable ", 3))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="bg-light-primary hoverable"></div>
            <div class="bg-light-success hoverable"></div>
            <div class="bg-light-info hoverable"></div>
            <div class="bg-light-warning hoverable"></div>
            <div class="bg-light-danger hoverable"></div>
            <div class="bg-light-dark hoverable"></div>
            `))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        _hoisted_41,
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors.opacity, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "d-flex flex-column me-5 mb-5"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([`opacity-${item}`, "w-90px h-90px bg-primary flex-grow-1"])
                }, null, 2),
                _createElementVNode("div", _hoisted_44, "bg-opacity-" + _toDisplayString(item), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="bg-opacity-0 bg-primary"></div>
            <div class="bg-opacity-5 bg-primary"></div>
            <div class="bg-opacity-10 bg-primary"></div>
            <div class="bg-opacity-15 bg-primary"></div>
            <div class="bg-opacity-20 bg-primary"></div>
            <div class="bg-opacity-25 bg-primary"></div>
            <div class="bg-opacity-50 bg-primary"></div>
            <div class="bg-opacity-75 bg-primary"></div>
            <div class="bg-opacity-100 bg-primary"></div>
            `))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createElementVNode("div", _hoisted_50, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div
              style="background-image: url(image.png)"
              class="bgi-size-contain bgi-no-repeat bgi-position-center"
            ></div>
            `), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}